const buildImagePromptMap = ({ results, source, prompt }) =>
    Object.fromEntries(results.map(result => [result.url, { source, prompt }]));

export default buildImagePromptMap;
